// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root DockPanel container */
.dock-panel {
    position: absolute;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    pointer-events: none;
    margin: 0.5rem 0rem;
    padding: 0.5rem;
    border-radius: 4px;
    width: 20vw;
}

 /* has at least one child */
    .dock-panel:has(*) {
        background-color: var(--color-component-transparent-background);
    }

/* Host items inside DockPanel */
.dock-panel-item {
    pointer-events: auto;
    width: 100%;
    height: 5rem;
}

/* Centre button (always visible) */
.dock-centre-button {
    width: 48px;
    height: 48px;
    position: absolute;
    pointer-events: auto;
    background-color: #00000088;
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

    .dock-centre-button:hover {
        background-color: #000000;
    }

/* TOP-LEFT → anchor = top-right */
.dock-panel.dock-top-left > .dock-centre-button,
.dock-panel.dock-top-left > .dock-grid-overlay {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
}

/* TOP → anchor = top-right */
.dock-panel.dock-top > .dock-centre-button,
.dock-panel.dock-top > .dock-grid-overlay {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
}

/* BOTTOM-LEFT → anchor = top-right */
.dock-panel.dock-bottom-left > .dock-centre-button,
.dock-panel.dock-bottom-left > .dock-grid-overlay {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
}

/* BOTTOM → anchor = top-right */
.dock-panel.dock-bottom > .dock-centre-button,
.dock-panel.dock-bottom > .dock-grid-overlay {
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
}

/* TOP-RIGHT → anchor = top-left */
.dock-panel.dock-top-right > .dock-centre-button,
.dock-panel.dock-top-right > .dock-grid-overlay {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
}

/* BOTTOM-RIGHT → anchor = top-left */
.dock-panel.dock-bottom-right > .dock-centre-button,
.dock-panel.dock-bottom-right > .dock-grid-overlay {
    top: 0;
    left: 0;
    transform: translate(-50%, -50%);
}

/* Overlay container for the 3×3 grid */
.dock-grid-overlay {
    position: absolute;
    pointer-events: auto;
}

/* TOP (full width across the top edge) */
.dock-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

/* BOTTOM (full width across the bottom edge) */
.dock-bottom {
    bottom: 10rem;
    left: 50%;
    transform: translateX(-50%);
}

/* TOP-LEFT (corner) */
.dock-top-left {
    top: 0;
    left: 0;
}

/* TOP-RIGHT (corner) */
.dock-top-right {
    top: 0;
    right: 2rem;
}

/* BOTTOM-LEFT (corner) */
.dock-bottom-left {
    bottom: 10rem;
    left: 0;
}

/* BOTTOM-RIGHT (corner) */
.dock-bottom-right {
    bottom: 10rem;
    right: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/Controls/DockPanel/css/DockPanel.css"],"names":[],"mappings":"AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;CAEC,2BAA2B;IACxB;QACI,+DAA+D;IACnE;;AAEJ,gCAAgC;AAChC;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;IAEI;QACI,yBAAyB;IAC7B;;AAEJ,kCAAkC;AAClC;;IAEI,MAAM;IACN,QAAQ;IACR,+BAA+B;AACnC;;AAEA,6BAA6B;AAC7B;;IAEI,MAAM;IACN,QAAQ;IACR,+BAA+B;AACnC;;AAEA,qCAAqC;AACrC;;IAEI,MAAM;IACN,QAAQ;IACR,+BAA+B;AACnC;;AAEA,gCAAgC;AAChC;;IAEI,MAAM;IACN,QAAQ;IACR,+BAA+B;AACnC;;AAEA,kCAAkC;AAClC;;IAEI,MAAM;IACN,OAAO;IACP,gCAAgC;AACpC;;AAEA,qCAAqC;AACrC;;IAEI,MAAM;IACN,OAAO;IACP,gCAAgC;AACpC;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA,yCAAyC;AACzC;IACI,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,SAAS;IACT,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,MAAM;IACN,OAAO;AACX;;AAEA,uBAAuB;AACvB;IACI,MAAM;IACN,WAAW;AACf;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,OAAO;AACX;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,WAAW;AACf","sourcesContent":["@import '../../../css/App.css';\r\n\r\n/* Root DockPanel container */\r\n.dock-panel {\r\n    position: absolute;\r\n    z-index: 999;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n    pointer-events: none;\r\n    margin: 0.5rem 0rem;\r\n    padding: 0.5rem;\r\n    border-radius: 4px;\r\n    width: 20vw;\r\n}\r\n\r\n /* has at least one child */\r\n    .dock-panel:has(*) {\r\n        background-color: var(--color-component-transparent-background);\r\n    }\r\n\r\n/* Host items inside DockPanel */\r\n.dock-panel-item {\r\n    pointer-events: auto;\r\n    width: 100%;\r\n    height: 5rem;\r\n}\r\n\r\n/* Centre button (always visible) */\r\n.dock-centre-button {\r\n    width: 48px;\r\n    height: 48px;\r\n    position: absolute;\r\n    pointer-events: auto;\r\n    background-color: #00000088;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1;\r\n}\r\n\r\n    .dock-centre-button:hover {\r\n        background-color: #000000;\r\n    }\r\n\r\n/* TOP-LEFT → anchor = top-right */\r\n.dock-panel.dock-top-left > .dock-centre-button,\r\n.dock-panel.dock-top-left > .dock-grid-overlay {\r\n    top: 0;\r\n    right: 0;\r\n    transform: translate(50%, -50%);\r\n}\r\n\r\n/* TOP → anchor = top-right */\r\n.dock-panel.dock-top > .dock-centre-button,\r\n.dock-panel.dock-top > .dock-grid-overlay {\r\n    top: 0;\r\n    right: 0;\r\n    transform: translate(50%, -50%);\r\n}\r\n\r\n/* BOTTOM-LEFT → anchor = top-right */\r\n.dock-panel.dock-bottom-left > .dock-centre-button,\r\n.dock-panel.dock-bottom-left > .dock-grid-overlay {\r\n    top: 0;\r\n    right: 0;\r\n    transform: translate(50%, -50%);\r\n}\r\n\r\n/* BOTTOM → anchor = top-right */\r\n.dock-panel.dock-bottom > .dock-centre-button,\r\n.dock-panel.dock-bottom > .dock-grid-overlay {\r\n    top: 0;\r\n    right: 0;\r\n    transform: translate(50%, -50%);\r\n}\r\n\r\n/* TOP-RIGHT → anchor = top-left */\r\n.dock-panel.dock-top-right > .dock-centre-button,\r\n.dock-panel.dock-top-right > .dock-grid-overlay {\r\n    top: 0;\r\n    left: 0;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n/* BOTTOM-RIGHT → anchor = top-left */\r\n.dock-panel.dock-bottom-right > .dock-centre-button,\r\n.dock-panel.dock-bottom-right > .dock-grid-overlay {\r\n    top: 0;\r\n    left: 0;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n/* Overlay container for the 3×3 grid */\r\n.dock-grid-overlay {\r\n    position: absolute;\r\n    pointer-events: auto;\r\n}\r\n\r\n/* TOP (full width across the top edge) */\r\n.dock-top {\r\n    top: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n/* BOTTOM (full width across the bottom edge) */\r\n.dock-bottom {\r\n    bottom: 10rem;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n}\r\n\r\n/* TOP-LEFT (corner) */\r\n.dock-top-left {\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n/* TOP-RIGHT (corner) */\r\n.dock-top-right {\r\n    top: 0;\r\n    right: 2rem;\r\n}\r\n\r\n/* BOTTOM-LEFT (corner) */\r\n.dock-bottom-left {\r\n    bottom: 10rem;\r\n    left: 0;\r\n}\r\n\r\n/* BOTTOM-RIGHT (corner) */\r\n.dock-bottom-right {\r\n    bottom: 10rem;\r\n    right: 2rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
